// Formatare RO — monedă EUR, separator zecimal virgulă, dată DD/MM/YYYY.

const LUNI_SCURT = [
  "ian", "feb", "mar", "apr", "mai", "iun",
  "iul", "aug", "sep", "oct", "noi", "dec",
];

const LUNI_LUNGI = [
  "ianuarie", "februarie", "martie", "aprilie", "mai", "iunie",
  "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie",
];

/** Formatează un `luna_key` de forma "2025-07" -> "iul 2025". */
export function formatLunaKey(lunaKey: string, lung = false): string {
  const [anStr, lunaStr] = lunaKey.split("-");
  const an = Number(anStr);
  const luna = Number(lunaStr);
  const nume = lung ? LUNI_LUNGI : LUNI_SCURT;
  if (!an || !luna || luna < 1 || luna > 12) return lunaKey;
  return `${nume[luna - 1]} ${an}`;
}

/** Formatează o dată ISO ("2025-07-08") -> "08/07/2025". */
export function formatDataRO(dataIso: string): string {
  const [an, luna, zi] = dataIso.split("-");
  if (!an || !luna || !zi) return dataIso;
  return `${zi}/${luna}/${an}`;
}

export function eur(n: number | null | undefined, decimale = 0): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return new Intl.NumberFormat("ro-RO", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: decimale,
    maximumFractionDigits: decimale,
  }).format(n);
}

export function numar(n: number | null | undefined, decimale = 1): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return new Intl.NumberFormat("ro-RO", {
    minimumFractionDigits: decimale,
    maximumFractionDigits: decimale,
  }).format(n);
}

export function procent(n: number | null | undefined, decimale = 1): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return `${numar(n, decimale)}%`;
}

/**
 * EUR scurt pentru axe/legende de chart — simbol „€" (nu „EUR"), fără zecimale,
 * cu prescurtare k/M pentru valori mari. Ține etichetele axei compacte ca să nu
 * fie tăiate de container.
 */
export function eurAxis(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `${numar(n / 1_000_000, 1)} mil. €`;
  if (abs >= 10_000) return `${numar(n / 1_000, 0)} k €`;
  if (abs >= 1_000) return `${numar(n / 1_000, 1)} k €`;
  if (abs > 0 && abs < 10) return `${numar(n, 1)} €`;
  return `${new Intl.NumberFormat("ro-RO", { maximumFractionDigits: 0 }).format(n)} €`;
}

/** Procent scurt pentru axe — fără zecimale. */
export function procentAxis(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return `${new Intl.NumberFormat("ro-RO", { maximumFractionDigits: 0 }).format(n)}%`;
}
